import React from 'react'
import styled from 'styled-components'
import { RareFlag } from '~/graphqls/types'

const RareColor: Record<string, string> = {
  [RareFlag.R]: '#4BC9F0',
  [RareFlag.SR]: '#7851EC',
  [RareFlag.SSR]: '#EF466F',
}

const StyledMyRare = styled.span<{
  rare: RareFlag
  large: boolean
}>`
  font-size: 12px;
  line-height: 12px;
  padding: ${props => (props.large ? '7px' : '4px')};
  width: ${props => (props.large ? '40px' : '32px')};
  border-radius: 4px;
  text-align: center;
  vertical-align: middle;
  display: inline-block;
  background: ${props => RareColor[props.rare]};
  color: ${props => props.theme.light3};
`

export const MyRare: React.FC<{
  rare: RareFlag
  large?: boolean
  className?: string
  style?: React.CSSProperties
}> = ({ rare, className, large = false, style }) => {
  return (
    <>
      {[RareFlag.R, RareFlag.SR, RareFlag.SSR].includes(rare) ? (
        <StyledMyRare
          style={style}
          className={className}
          rare={rare}
          large={large}
        >
          {rare}
        </StyledMyRare>
      ) : (
        <></>
      )}
    </>
  )
}
